import type { ButtonHTMLAttributes } from 'vue';

export function getButtonType(
  type: unknown
): NonNullable<ButtonHTMLAttributes['type']> {
  return type === 'submit' || type === 'reset' ? type : 'button';
}
